import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const ResolvedIcon16 = (props: SvgProps) => <Svg
  width='16'
  height='16'
  viewBox='0 0 16 16'
  fill='none'
  {...props}
>
  <Path
    d='M2 8.21053L5.85714 12L14 4'
    stroke='#005F09'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
</Svg>;

export default ResolvedIcon16;
